<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" size="small" label-width="100px" :rules="rules" ref="form">
      <el-form-item label="原始密码" prop="oldpassword">
        <el-input show-password v-model.trim="form.oldpassword" clearable maxlength="14"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="password">
        <el-input show-password v-model.trim="form.password" clearable maxlength="14"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="repassword">
        <el-input show-password v-model.trim="form.repassword" clearable maxlength="14"></el-input>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty,checkPwd} from '@utils/validate'
  export default {
    name: "ResetPassword",
    props: {dialogData: Object},
    data() {
      const checkRePass = (rule, value, callback) => {
        if (value !== this.form.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        form: {
          oldpassword: "",
          password: "",
          repassword: "",
        },
        rules: {
          oldpassword: [inputEmpty("原始密码")],
          password: [inputEmpty("新密码"), checkPwd()],
          repassword: [inputEmpty('确认密码'), {validator: checkRePass, trigger: 'blur'}],
        },
      }
    },
    methods: {
      confirm() {
        this.$refs["form"].validate(isOk => {
          if (isOk) {
            this.openConfirm("修改管理员密码", async () => {
              let nv = {...this.form};
              let res = await this.$Http.revisePassword(nv);
              if (res) {
                this.msgSuccess("修改成功");
                this.$emit("table-reload");
                this.dialogData.visible = false;
              }
            });
          }
        });
      },
    },
  }
</script>

<style scoped>

</style>
